import { getTenant, getTenantList } from '#/graphql/queries';
import FieldDefs from '#/types/FieldDefs';
import { gql } from '@apollo/client';

type BaseColumnsType = { tenantId?: string | null };

export const getBaseColumns = () => {
  return {
    tenantId: {
      dataField: 'tenantId',
      label: 'Organization',
      editorType: 'RelatedItems',
      editorOptions: {
        readOnly: true,
        placeholder: 'Search tenants...',
        button: {
          icon: 'buildings',
          readOnly: true,
        },
        displayExpr: 'name',
        valueExpr: 'id',
        dataStoreOptions: {
          getItemList: gql(getTenantList),
          getItem: gql(getTenant),
        },
      },
    },
  } satisfies FieldDefs<BaseColumnsType>;
};
